// extracted by mini-css-extract-plugin
export default {"attributesContainer":"Attributes_attributesContainer__WqKtJ","backButton":"Attributes_backButton__32jJc"};